import config from '@/config'
import GeolocationManager from '@/library/geolocation/services/geolocationManager'
import Vue from 'vue'
import store from '@/store'

const isDebug = sessionStorage.geolocationDebug
const GEOLOCATION_CONFIG = config.app.autoconf.GEOLOCATION
const SOLUTION = GEOLOCATION_CONFIG && GEOLOCATION_CONFIG.XPOINT && GEOLOCATION_CONFIG.XPOINT.SOLUTION
const solutionCheck = {
  Lite: 'WebSdkLite',
  Verify: 'WebSdk'
}
let geoManager = null
/* Lite solution options only */
const defaultLiteOptions = {
  checkStatusPositionOptions: {
    timeout: 15 * 1000, // Typically, 15 to 30 seconds suffices, though the timeout may vary based on the UX (giving adequate time for granting location permission in a web browser)
    maximumAge: 60 * 60 * 1000,
    enableHighAccuracy: true
  },
  watchPositionOptions: {
    timeout: 60 * 1000,
    maximumAge: 300 * 1000,
    enableHighAccuracy: true
  }
}

class XpjsService {
  static instance = null

  constructor () {
    if (XpjsService.instance) return XpjsService.instance

    this.xpjs = null
    this.subscription = null
    this.options = {}
    this.solution = SOLUTION

    XpjsService.instance = this
  }

  static getInstance () {
    if (!XpjsService.instance) {
      XpjsService.instance = new XpjsService()
    }
    return XpjsService.instance
  }

  async init (onLoad = false) {
    if (!window.xpoint || !window.xpoint[solutionCheck[this.solution]]) {
      throw new Error('[XPoint] SDK not initialized.')
    }
    if (!this.xpjs) {
      if (this.solution === 'Lite') this.options = defaultLiteOptions
      this.xpjs = window.xpoint[solutionCheck[this.solution]].getInstance(this.options)
      if (isDebug) console.log(`[XPoint] ${this.solution} instance is ready.`)
      if (this.solution === 'Lite' && onLoad) {
        let perm = await this.checkPermissions()
        let geoError = localStorage.geoError && localStorage.geoError === 'BROWSER_LOCATION_DENIED'
        console.log('XPOINT checking browser location permission on load.', perm)
        console.log('XPOINT checking browser location permission on load and has stored error?.', geoError)
        if (perm.length === 0 && geoError) {
          let userId = localStorage.customer
          let errorCode = 'verify'
          store.commit('overlayState/setGeolocationMessage', { errorCode })
          localStorage.setItem('geoError', false)
          managerInstance.geolocationManager.initGeolocation(userId, false, 'Login')
          console.log('XPOINT start geolocation again')
        }
      }
      return true
    }
  }

  async getSubscription () {
    return this.subscription
  }

  async isVerifyActive () {
    this.init()
    try {
      return await this.xpjs.isVerifyActive()
    } catch (e) {
      if (isDebug) console.log('[XPoint] Verify active check error:', e)
      return false
    }
  }

  async checkStatus (options) {
    this.init()
    try {
      return await this.xpjs.checkStatus(options)
    } catch (e) {
      this.handleError(e)
      throw e
    }
  }

  async checkStatusSync (options, timeout = 30000) {
    this.init()
    try {
      this.options = options
      return await this.xpjs.checkStatusSync(options, timeout)
    } catch (e) {
      this.handleError(e)
      throw e
    }
  }

  async liteCheck (options, forceRefresh) {
    this.init()
    try {
      return await this.xpjs.liteCheck(options, forceRefresh)
    } catch (e) {
      this.handleError(e)
      throw e
    }
  }

  subscribe (options, handler) {
    this.init()
    if (this.subscription) {
      this.unsubscribe()
    }
    this.xpjs.subscribe(options, handler)
    this.subscription = handler
    this.options = options
    if (isDebug) console.log('[XPoint] Subscribed to Xpoint status changes.')
  }

  unsubscribe (forceAll) {
    if (!this.xpjs) return
    if (this.options && this.subscription && !forceAll) {
      if (isDebug) console.log('[XPoint] Unsubscribing from geolocation subscription.')
      this.xpjs.unsubscribe(this.options, this.subscription)
    } else {
      if (isDebug) console.log('[XPoint] Unsubscribing all handlers of all sessions.')
      this.xpjs.unsubscribe()
    }
    this.subscription = null
    this.options = null
  }

  async checkPermissions () {
    return this.xpjs.checkPermissions()
  }

  handleError (e) {
    if (!e) return

    const name = e.name || ''
    switch (name) {
      case 'VerifyIsNotAvailableError':
        if (isDebug) console.log('Verify is not available or not running.')
        break
      case 'ClientNotFoundError':
        if (isDebug) console.log('ClientKey does not exist.')
        break
      case 'IllegalArgumentError':
        if (isDebug) console.log('userId or clientKey was not provided.')
        break
      case 'TimeoutError':
        if (isDebug) console.log('Status check timed out.')
        break
      default:
        if (isDebug) console.log('Unexpected error:', e)
    }
  }
}

const managerInstance = {
  get geolocationManager () {
    if (!geoManager) geoManager = GeolocationManager.getInstance(config.app.autoconf.GEOLOCATION.PROVIDER, Vue.prototype.$geolocationDebug)
    return geoManager
  }
}

const xpjsService = XpjsService.getInstance()
export default xpjsService



// WEBPACK FOOTER //
// ./src/library/geolocation/services/providers/xpoint/xpjsService.js